var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { width: "72%" } }, [
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "space-between"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("Pieces")]),
                  _c("el-input-number", {
                    class: _vm.importDifferenceField.quantity
                      ? "red-border"
                      : "",
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      no: "1",
                      value: _vm.cargoDoc.quantity || undefined,
                      min: 0,
                      max: 999999999999,
                      precision: 0,
                      disabled: !_vm.isEdit,
                      "controls-position": "right",
                      controls: false
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.quantity = val
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("Gross Weight")]),
                  _c("el-input-number", {
                    class: _vm.importDifferenceField.weight ? "red-border" : "",
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      no: "2",
                      value: _vm.cargoDoc.weight || undefined,
                      min: 0,
                      max: 999999999999,
                      precision: 3,
                      disabled: !_vm.isEdit,
                      controls: false,
                      "controls-position": "right"
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.weight = val
                      },
                      change: function($event) {
                        _vm.weightChangeHandler
                        _vm.commonChangeHandler("weight")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("KG-LB")]),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.kglb ? "red-border" : "",
                      staticStyle: { width: "70px" },
                      attrs: { disabled: !_vm.isEdit, no: "3" },
                      model: {
                        value: _vm.cargoDoc.kglb,
                        callback: function($$v) {
                          _vm.$set(_vm.cargoDoc, "kglb", $$v)
                        },
                        expression: "cargoDoc.kglb"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "K", value: "K" } }),
                      _c("el-option", { attrs: { label: "L", value: "L" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("Rate Class")]),
                  _c(
                    "el-select",
                    {
                      class: _vm.importDifferenceField.rateClass
                        ? "red-border"
                        : "",
                      staticStyle: { width: "70px" },
                      attrs: {
                        disabled: !_vm.isEdit,
                        no: "4",
                        placeholder: !_vm.isEdit
                          ? ""
                          : _vm.$t("SeaExport.PleaseSelect")
                      },
                      on: { change: _vm.rateClassChangeHandler },
                      model: {
                        value: _vm.cargoDoc.rateClass,
                        callback: function($$v) {
                          _vm.$set(_vm.cargoDoc, "rateClass", $$v)
                        },
                        expression: "cargoDoc.rateClass"
                      }
                    },
                    _vm._l(_vm.AirExportConstants.RATE_CLASSES, function(item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c("span", [_vm._v("C.Weight")]),
                  _c("el-input-number", {
                    class: _vm.importDifferenceField.cWeight
                      ? "red-border"
                      : "",
                    staticStyle: { width: "120px", "margin-right": "5px" },
                    attrs: {
                      no: "5",
                      value: _vm.cargoDoc.cWeight || undefined,
                      min: 0,
                      max: 999999999999,
                      precision: 1,
                      disabled: !_vm.isEdit,
                      "controls-position": "right",
                      controls: false
                    },
                    on: {
                      input: function(val) {
                        _vm.cargoDoc.cWeight = val || 0
                      },
                      change: function($event) {
                        _vm.cWeightChangeHandler()
                        _vm.commonChangeHandler("cWeight")
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    width: "100px",
                    "margin-right": "2px"
                  }
                },
                [
                  _c("span", [_vm._v("Rate Charge")]),
                  _c("el-input", {
                    class: _vm.importDifferenceField.rateCharge
                      ? "red-border"
                      : "",
                    attrs: { disabled: !_vm.isEdit, no: "6" },
                    on: {
                      change: function($event) {
                        return _vm.commonChangeHandler("rateCharge")
                      }
                    },
                    model: {
                      value: _vm.cargoDoc.rateCharge,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "rateCharge", $$v)
                      },
                      expression: "cargoDoc.rateCharge"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    width: "100px"
                  }
                },
                [
                  _c("span", [_vm._v("Total")]),
                  _c("cargo-input", {
                    class: _vm.importDifferenceField.cTotal ? "red-border" : "",
                    attrs: {
                      disabled: !_vm.isEdit,
                      no: "7",
                      "auto-uppercase": true
                    },
                    on: {
                      blur: function($event) {
                        return _vm.commonChangeHandler("cTotal")
                      }
                    },
                    model: {
                      value: _vm.cargoDoc.cTotal,
                      callback: function($$v) {
                        _vm.$set(_vm.cargoDoc, "cTotal", $$v)
                      },
                      expression: "cargoDoc.cTotal"
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("div", [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("SLAC")]),
                _c("el-input-number", {
                  class: _vm.importDifferenceField.slac ? "red-border" : "",
                  staticStyle: { width: "85px" },
                  attrs: {
                    value: _vm.cargoDoc.slac || undefined,
                    disabled: !_vm.isEdit,
                    no: "slac",
                    min: 0,
                    precision: 0,
                    controls: false
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.slac = val || 0
                    }
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Remark")]),
                _c("cargo-rich-textarea", {
                  class: _vm.importDifferenceField.remark1 ? "red-border" : "",
                  staticStyle: { height: "186px" },
                  attrs: {
                    no: "8",
                    "text-chars": 0,
                    "warning-count": -1,
                    "auto-uppercase": _vm.isUppercaseByConfig,
                    disabled: !_vm.isEdit
                  },
                  on: {
                    blur: function($event) {
                      return _vm.markChangeHandler()
                    }
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Remark",
                        _vm.cargoDoc.remark1,
                        function(val) {
                          _vm.cargoDoc.remark1 = val
                        }
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.remark1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "remark1", $$v)
                    },
                    expression: "cargoDoc.remark1"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c(
          "div",
          {
            staticStyle: {
              "flex-grow": "1",
              width: "28%",
              "margin-left": "5px"
            }
          },
          [
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Nature and Quantity of Goods")]),
                _c("cargo-rich-textarea", {
                  class: _vm.importDifferenceField.cargoEnglishName
                    ? "red-border"
                    : "",
                  attrs: {
                    no: "9",
                    "show-count": true,
                    disabled: !_vm.isEdit,
                    "text-chars": 0,
                    "english-letter-auto-uppercase": _vm.isUppercaseByConfig,
                    "warning-count": -1
                  },
                  on: {
                    blur: function($event) {
                      return _vm.cargoEnglishNameChangeHandler()
                    }
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Nature and Quantity of Goods",
                        _vm.cargoDoc.cargoEnglishName,
                        function(val) {
                          _vm.cargoDoc.cargoEnglishName = val
                        },
                        _vm.isUppercaseByConfig
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cargoEnglishName,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cargoEnglishName", $$v)
                    },
                    expression: "cargoDoc.cargoEnglishName"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Dimension")]),
                _c("cargo-rich-textarea", {
                  class: _vm.importDifferenceField.dimension
                    ? "red-border"
                    : "",
                  attrs: {
                    no: "10",
                    disabled: !_vm.isEdit,
                    "text-chars": 0,
                    "warning-count": -1,
                    "auto-uppercase": true,
                    type: "textarea",
                    rows: 2
                  },
                  nativeOn: {
                    dblclick: function($event) {
                      return _vm.showAdvanceTextDialog(
                        "Dimension",
                        _vm.cargoDoc.dimension,
                        function(val) {
                          _vm.cargoDoc.dimension = val
                        }
                      )
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.dimension,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "dimension", $$v)
                    },
                    expression: "cargoDoc.dimension"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _c("span", [_vm._v("Volume")]),
                _c("el-input-number", {
                  class: _vm.importDifferenceField.cubage ? "red-border" : "",
                  staticStyle: { width: "100%", "margin-right": "5px" },
                  attrs: {
                    no: "11",
                    value: _vm.cargoDoc.cubage || undefined,
                    min: 0,
                    max: 999999999999,
                    precision: 3,
                    disabled: !_vm.isEdit,
                    "controls-position": "right",
                    controls: false
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cubage = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("cubage")
                    }
                  }
                })
              ],
              1
            )
          ]
        )
      ]),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticStyle: { "margin-right": "5px" } }, [
          _c("div", [
            _vm._m(0),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  class: _vm.importDifferenceField.pp1 ? "red-border" : "",
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "12",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp1 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP1")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp1", $$v)
                    },
                    expression: "cargoDoc.pp1"
                  }
                }),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.cc1 ? "red-border" : "",
                  attrs: {
                    no: "13",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc1 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC1")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc1,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc1", $$v)
                    },
                    expression: "cargoDoc.cc1"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(1),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  class: _vm.importDifferenceField.pp2 ? "red-border" : "",
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "14",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    blur: function($event) {
                      return _vm.commonChangeHandler("PP2")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp2", $$v)
                    },
                    expression: "cargoDoc.pp2"
                  }
                }),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.cc2 ? "red-border" : "",
                  attrs: {
                    no: "15",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    blur: function($event) {
                      return _vm.commonChangeHandler("CC2")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc2,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc2", $$v)
                    },
                    expression: "cargoDoc.cc2"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(2),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  class: _vm.importDifferenceField.pp3 ? "red-border" : "",
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "16",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.PP
                  },
                  on: {
                    blur: function($event) {
                      return _vm.commonChangeHandler("PP3")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp3,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp3", $$v)
                    },
                    expression: "cargoDoc.pp3"
                  }
                }),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.cc3 ? "red-border" : "",
                  attrs: {
                    no: "17",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.wtVal !== _vm.AirExportConstants.CC
                  },
                  on: {
                    blur: function($event) {
                      return _vm.commonChangeHandler("CC3")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc3,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc3", $$v)
                    },
                    expression: "cargoDoc.cc3"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(3),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  class: _vm.importDifferenceField.pp4 ? "red-border" : "",
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    no: "18",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.other !== _vm.AirExportConstants.PP
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp4 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP4")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp4,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp4", $$v)
                    },
                    expression: "cargoDoc.pp4"
                  }
                }),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.cc4 ? "red-border" : "",
                  attrs: {
                    no: "19",
                    "auto-uppercase": true,
                    disabled:
                      !_vm.isEdit ||
                      _vm.cargoDoc.other !== _vm.AirExportConstants.CC
                  },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc4 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC4")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc4,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc4", $$v)
                    },
                    expression: "cargoDoc.cc4"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(4),
            _c(
              "div",
              { staticStyle: { display: "flex", "justify-content": "center" } },
              [
                _c("cargo-input", {
                  staticStyle: { "margin-right": "2px" },
                  attrs: { no: "20", "auto-uppercase": true, disabled: true },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.pp5 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("PP5")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp5,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp5", $$v)
                    },
                    expression: "cargoDoc.pp5"
                  }
                }),
                _c("cargo-input", {
                  attrs: { no: "21", "auto-uppercase": true, disabled: true },
                  on: {
                    input: function(val) {
                      _vm.cargoDoc.cc5 = val
                    },
                    change: function($event) {
                      return _vm.commonChangeHandler("CC5")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.cc5,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc5", $$v)
                    },
                    expression: "cargoDoc.cc5"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", [
            _vm._m(5),
            _c(
              "div",
              { staticStyle: { display: "flex" } },
              [
                _c("cargo-input", {
                  class: _vm.importDifferenceField.pp6 ? "red-border" : "",
                  staticStyle: { "margin-right": "2px" },
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "22",
                    "auto-uppercase": true
                  },
                  on: {
                    change: function($event) {
                      return _vm.commonChangeHandler("PP6")
                    }
                  },
                  model: {
                    value: _vm.cargoDoc.pp6,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "pp6", $$v)
                    },
                    expression: "cargoDoc.pp6"
                  }
                }),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.cc6 ? "red-border" : "",
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "23",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.cc6,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "cc6", $$v)
                    },
                    expression: "cargoDoc.cc6"
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c("div", [
          _c(
            "div",
            [
              _c("other-charge-grid", {
                ref: "otherChargeGrid",
                attrs: {
                  "cargo-doc": _vm.cargoDoc,
                  action: _vm.action,
                  job: _vm.job
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "7px" } },
            [
              _c("span", [_vm._v("Signature of Shipper or his Agent")]),
              _c("cargo-input", {
                class: _vm.importDifferenceField.signByShipper
                  ? "red-border"
                  : "",
                attrs: {
                  disabled: !_vm.isEdit,
                  no: "24",
                  "auto-uppercase": true
                },
                model: {
                  value: _vm.cargoDoc.signByShipper,
                  callback: function($$v) {
                    _vm.$set(_vm.cargoDoc, "signByShipper", $$v)
                  },
                  expression: "cargoDoc.signByShipper"
                }
              })
            ],
            1
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  "margin-right": "2px",
                  display: "flex",
                  "flex-direction": "column"
                }
              },
              [
                _c("span", [_vm._v("Executed on (date)")]),
                _c("el-date-picker", {
                  class: _vm.importDifferenceField.signDateBL
                    ? "red-border"
                    : "",
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "25",
                    clearable: "",
                    type: "date",
                    format: "yyyy-MM-dd",
                    "value-format": "yyyy-MM-dd"
                  },
                  model: {
                    value: _vm.cargoDoc.signDateBL,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signDateBL", $$v)
                    },
                    expression: "cargoDoc.signDateBL"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticStyle: { "margin-right": "2px" } },
              [
                _c("span", [_vm._v("at (place)")]),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.signPlaceBL
                    ? "red-border"
                    : "",
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "26",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.signPlaceBL,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signPlaceBL", $$v)
                    },
                    expression: "cargoDoc.signPlaceBL"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              [
                _c("span", [
                  _vm._v("Signature of Issuing Carrier or its Agent")
                ]),
                _c("cargo-input", {
                  class: _vm.importDifferenceField.signByCarrier
                    ? "red-border"
                    : "",
                  attrs: {
                    disabled: !_vm.isEdit,
                    no: "27",
                    "auto-uppercase": true
                  },
                  model: {
                    value: _vm.cargoDoc.signByCarrier,
                    callback: function($$v) {
                      _vm.$set(_vm.cargoDoc, "signByCarrier", $$v)
                    },
                    expression: "cargoDoc.signByCarrier"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            staticStyle: { height: "320px" },
            attrs: {
              disabled: !_vm.isEdit,
              "text-chars": 0,
              "auto-uppercase": !_vm.advanceTextDialog
                .onlyEnglishLeterUppercase,
              "english-letter-auto-uppercase":
                _vm.advanceTextDialog.onlyEnglishLeterUppercase,
              "warning-count": -1
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { no: "28", type: "primary" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "29" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-around" } },
      [
        _c("span", [_vm._v("Prepaid")]),
        _c("span", [_vm._v("Weight Charge")]),
        _c("span", [_vm._v("Collect")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Valuation")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Tax")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "center" } },
      [_c("span", [_vm._v("Total other Charges Due Agent")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "justify-content": "center",
          "padding-top": "7px"
        }
      },
      [_c("span", [_vm._v("Total other Charges Due Carrier")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "flex", "justify-content": "space-around" } },
      [
        _c("span", [_vm._v("Total prepaid")]),
        _c("span", [_vm._v("Total collect")])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }